import { render } from "./TrendingStoriesRail.vue?vue&type=template&id=68c08ed6&scoped=true"
import script from "./TrendingStoriesRail.vue?vue&type=script&lang=js"
export * from "./TrendingStoriesRail.vue?vue&type=script&lang=js"

import "./TrendingStoriesRail.vue?vue&type=style&index=0&id=68c08ed6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c08ed6"]])

export default __exports__